export const initVBO = (gl: WebGLRenderingContext): void => {
  const VERTICES = new Float32Array([-1, -1, 3, -1, -1, 3]);

  const vertexBuffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
  gl.bufferData(gl.ARRAY_BUFFER, VERTICES, gl.STATIC_DRAW);
};
